<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Button from '../../../Button.svelte';
  import Input from '../../../Input.svelte';
  import Textarea from '../../../Textarea.svelte';
  
  export let loading = false;

  const dispatch = createEventDispatcher();

  let charityName = '';
  let website = '';
  let reason_for_request = '';
  let contact_email = '';

  function handleSubmit() {
    if (!charityName.trim() || !contact_email.trim()) {
      dispatch('error', { message: 'Please fill all required fields' });
      return;
    }

    const inviteData = {
      name: charityName.trim(),
      contact_email: contact_email.trim(),
      website: website.trim() || undefined,
      reason_for_request: reason_for_request.trim() || undefined
    };

    dispatch('submit', { data: inviteData });
  }

  function handleCancel() {
    dispatch('cancel');
  }

  function handleBack() {
    dispatch('back');
  }
</script>

<div class="step-container">
  <div class="step-header">
    <button class="back-button" on:click={handleBack}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H6m6-6l-6 6 6 6"/>
      </svg>
    </button>
    <h2>Invite a Charity</h2>
  </div>

  <div class="step-description">
    <p>Request a new charity to be added to the platform</p>
  </div>

  <div class="step-content">
    <div class="form-group">
      <Input
        label="Charity Name"
        bind:value={charityName}
        placeholder="Enter charity name"
        required={true}
        disabled={loading}
        fullWidth={true}
      />
    </div>

    <div class="form-group">
      <Input
        label="Contact Email"
        bind:value={contact_email}
        placeholder="Enter contact email"
        type="email"
        required={true}
        disabled={loading}
        fullWidth={true}
      />
    </div>

    <div class="form-group">
      <Input
        label="Website (Optional)"
        bind:value={website}
        placeholder="https://www.charity.org"
        type="url"
        disabled={loading}
        fullWidth={true}
      />
    </div>

    <div class="form-group">
      <Textarea
        label="Reason for Request (Optional)"
        bind:value={reason_for_request}
        placeholder="Why would you like this charity to be added?"
        required={false}
        disabled={loading}
        fullWidth={true}
        rows={4}
      />
    </div>
  </div>

  <div class="step-actions">
    <Button 
      variant="primary" 
      fullWidth={true}
      on:click={handleSubmit}
      disabled={loading || !charityName.trim() || !contact_email.trim()}
    >
      <span class="button-content">
        <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2"
          class="plus-icon"
          aria-hidden="true"
        >
          <path d="M12 5v14m-7-7h14"/>
        </svg>
        <span class="button-text">{loading ? 'Sending Invitation...' : 'Invite a Charity'}</span>
      </span>
    </Button>
    <Button 
      variant="secondary" 
      fullWidth={true}
      on:click={handleCancel}
      disabled={loading}
    >
      Cancel
    </Button>
  </div>
</div>

<style>
  .step-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
    max-width: 500px;
    margin: 0 auto;
  }

  .step-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.5rem;
  }

  .back-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    color: #6b7280;
    transition: all 0.2s ease;
  }

  .back-button:hover {
    background-color: #f3f4f6;
    color: #374151;
  }

  .step-header h2 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
  }

  .step-description {
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .step-description p {
    color: #6b7280;
    margin: 0;
  }

  .step-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .step-actions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1rem;
  }

  .button-content {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    line-height: 1;
    vertical-align: middle;
  }

  .plus-icon {
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -0.0625em; /* Fine-tune vertical alignment */
  }

  .button-text {
    display: inline-block;
    vertical-align: middle;
  }
</style> 